<template>
  <button
    type="button"
    class="button-morph-details"
    @click="open = !open"
    :class="{
      'is-open': open,
    }"
  >
    <div class="button-morph-details__icon">
      <img
        src="@/assets/img/ico/ico-close-white.svg"
        width="18"
        height="18"
        alt="close"
      />
    </div>

    <div class="button-morph-details__text text-s-1 is-text-uppercase">
      <span>{{ label }}</span>
    </div>
  </button>
</template>

<script>
export default {
  name: 'WidgetButtonMorphDetails',
}
</script>

<script setup>
const props = defineProps({
  label: String,
})

const open = ref(false)
</script>

<style lang="scss">
@import './style.scss';
</style>
